import { customAxios } from '../../common/customAxios';

export const patchMyPokeTractor = (tractorId: string) => {
  return customAxios.patch(`/users-own-tractors/${tractorId}/pokes/restore`);
};
